import { Button, Drawer } from "@components";
import { useEffect, useState } from "react";

import styles from "@styles/forms-flow/forms.module.scss";
import classNames from "classnames/bind";

const css = classNames.bind(styles);

export const DayOfWeekConditionalForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
}) => {
  const [selectedDays, setSelectedDays] = useState(node.data?.days || []);

  const isSelectedDay = (day) => selectedDays.includes(day);
  const selectDaysWeek = (day) => {
    let tempArr = selectedDays;
    const index = tempArr.indexOf(day);

    if (index > -1) {
      tempArr = tempArr.filter((item) => item !== day);
    } else tempArr = [...tempArr, day];

    setSelectedDays(tempArr);
  };

  useEffect(() => {
    onChange &&
      onChange({ ...node, data: { ...node.data, days: selectedDays } });
  }, [selectedDays]);

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title="Em dias específicos da semana"
    >
      <div className={styles.daysWeek}>
        <p className={styles.label}>Defina os dias da semana</p>

        <div className={styles.days}>
          {days.map((day, _i) => (
            <div
              className={css({ day: true, isSelected: isSelectedDay(day.id) })}
              onClick={() => selectDaysWeek(day.id)}
            >
              {day.day}
            </div>
          ))}
        </div>

        <div className={styles.footer}>
          <Button
            onClick={() =>
              onSave({ ...node, data: { ...node.data, days: selectedDays } })
            }
            className="w-100"
            design="primary"
          >
            Aplicar
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

const days = [
  {
    id: 1,
    day: "D",
  },
  {
    id: 2,
    day: "S",
  },
  {
    id: 3,
    day: "T",
  },
  {
    id: 4,
    day: "Q",
  },
  {
    id: 5,
    day: "Q",
  },
  {
    id: 6,
    day: "S",
  },
  {
    id: 7,
    day: "S",
  },
];
